export default __webpack_public_path__ + "static/media/senor_tick_tock.d7476942.png";